import { selfInstantiateOnLoad } from "../utils";
export default class SpecialsScanMode {
    constructor() {
        const scanMode = document.querySelector("[data-scan-mode='true']");
        if (!scanMode) {
            return;
        }
        const disclosures = this.collectDisclosures();
        if (disclosures.length === 0) {
            return;
        }
        scanMode.appendChild(this.buildContainer(disclosures));
    }
    collectDisclosures() {
        const disclosures = [];
        document
            .querySelectorAll(".dgDisclaimersModal .modal-body")
            .forEach((el) => {
            if (el.innerHTML.trim()) {
                disclosures.push(el.innerHTML);
            }
        });
        document
            .querySelectorAll("[data-target='#moreInfoModal']")
            .forEach((trigger) => {
            const content = trigger.dataset.content;
            if (content) {
                disclosures.push(content);
            }
        });
        document
            .querySelectorAll("#smsLeadModal .modal-disclaimer, #smsLeadModal .help-block")
            .forEach((el) => {
            if (el.innerHTML.trim()) {
                disclosures.push(el.innerHTML);
            }
        });
        return disclosures;
    }
    buildContainer(disclosures) {
        const section = document.createElement("section");
        section.className = "specials-scan-disclaimers";
        section.dataset.scanDisclaimers = "";
        const list = document.createElement("div");
        list.className = "specials-scan-disclaimers__list";
        list.innerHTML = disclosures.join("");
        section.appendChild(list);
        return section;
    }
}
selfInstantiateOnLoad(SpecialsScanMode);
